import { LeaveType } from './enum.js';

export const HOURLY_LEAVE_TYPES = [LeaveType.ANNUAL, LeaveType.UNPAID] as const;
export type HourlyLeaveType = (typeof HOURLY_LEAVE_TYPES)[number];

export const WORK_HOURS_PER_DAY = 8;
export const MIN_HOURLY_LEAVE_MINUTES = 30;
export const LEAVE_DAY_MINUTES = WORK_HOURS_PER_DAY * 60;
// Leave request durationInDays is stored as DECIMAL(5,2), so request usage is rounded to two decimals.
export const LEAVE_REQUEST_DAY_DECIMAL_PRECISION = 2;
// Employee.leaveDayCount is DOUBLE PRECISION; keep half-hour entitlement fractions such as 0.0625 intact.
export const LEAVE_ENTITLEMENT_DAY_DECIMAL_PRECISION = 4;
